import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const manageTeamMember = async (userId, teamId, action) => {
  const token = await firebase.auth().currentUser.getIdToken()

  if (action !== 'leave' && action !== 'remove') {
    throw new Error('Invalid action')
  }

  const { data } = await AxiosConfig.post(`/team/${teamId}/members/manage`, {
    memberId: userId,
    action
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const createInvitation = async (toEmail, teamId) => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.post('/team/invite', {
    toEmail,
    teamId,
    useV2: true
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const respondToInvitation = async (invitationId, status) => {
  const token = await firebase.auth().currentUser.getIdToken()

  const { data } = await AxiosConfig.post(`/team/invite/${invitationId}/respond`, {
    action: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const setupWorkspace = async (teamId, invitedEmails = []) => {
  const user = firebase.auth().currentUser
  if (!user) return
  const token = await user.getIdToken()

  const { data } = await AxiosConfig.post('/team/setup-workspace', {
    teamId,
    invitedEmails
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  return data
}

const getTeamInvitePreview = async (token) => {
  const { data } = await AxiosConfig.get(`/fs/preview/invite/${token}`)

  return data
}
export default {
  createInvitation,
  respondToInvitation,
  manageTeamMember,
  setupWorkspace,
  getTeamInvitePreview
}
